import { render, staticRenderFns } from "./purchaseReturnDetail.vue?vue&type=template&id=1fbea7a9&scoped=true&"
import script from "./purchaseReturnDetail.vue?vue&type=script&lang=js&"
export * from "./purchaseReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./purchaseReturnDetail.vue?vue&type=style&index=0&id=1fbea7a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbea7a9",
  null
  
)

export default component.exports